/* eslint-disable no-useless-escape */
import React, { useState, useContext, FC } from 'react'
import { useHistory } from 'react-router-dom'
import { Button, List, ListItem, ListItemText } from '@material-ui/core'
import SignupLayout from '../../layout'
import LeftImageSection from '../../layout/leftImageSection'
import { SignupContext } from '../../context/SignupContextContainer'
import SIGNUP_STEPS from '../../utils/constants'

const items = [
  'LIST YOUR LAST 10 CLOSED OPPORTUNITIES',
  '3 BEST INDUSTRIES TO CONTACT',
  'TITLES OF YOUR TOP 3 CUSTOMERS',
  'DESIRED SIZE OF COMPANIES TO CONTACT',
]

const Customer: FC = () => {
  const { setSignupStep } = useContext(SignupContext)
  const [selected, setSelected] = useState(-1)
  const history = useHistory()

  const title = (): JSX.Element => {
    return (
      <div className="left-title">
        <p className="confirm-title">FIND THE</p>
        <p className="confirm-title">RIGHT PEOPLE. </p>
        <p className="confirm-title">CONNECT AT </p>
        <p className="confirm-title">THE RIGHT TIME. </p>
      </div>
    )
  }

  const toCriteria = (): void => {
    setSignupStep(SIGNUP_STEPS.CRITERIA)
    history.push('/client/criteria')
  }

  const goBack = (): void => {
    setSignupStep(SIGNUP_STEPS.RECON)
    history.push('/client/recon')
  }

  return (
    <SignupLayout>
      <LeftImageSection title={title()} img="/assets/images/9.jpg" />
      <div className="signup-form">
        <p className="sub-title no-border">
          TELL US A LITTLE ABOUT YOUR CURRENT AND IDEAL CUSTOMERS
        </p>
        <div className="form">
          <List component="nav" className="list">
            {items.map((item, id) => (
              <ListItem
                button
                key={item}
                className="listItem"
                selected={selected === id}
                onClick={(): void => setSelected(id)}
              >
                <ListItemText primary={item} />
              </ListItem>
            ))}
          </List>
          <div className="button-container">
            <Button
              size="large"
              variant="contained"
              color="primary"
              style={{ marginRight: 20 }}
              disabled={selected < 0}
              onClick={toCriteria}
            >
              Enable RECON
            </Button>
            <Button size="medium" color="primary" className="skipThis" onClick={goBack}>
              Go Back.
            </Button>
          </div>
        </div>
      </div>
    </SignupLayout>
  )
}
export default Customer
